import { apiRequest } from "@alba-cars/common-modules";

import { PaginatedResponse } from "@/components/common/forms/FormAutoComplete";

interface DealDriveTrim {
  node: {
    id: number;
    name: string;
    catalogModel: {
      id: string;
      name: string;
      __typename: "CatalogModel";
    };
    catalogBrand: {
      id: string;
      name: string;
      __typename: "CatalogBrand";
    };
    __typename: "CatalogTrim";
  };
}

export const getDealDriveTrims = async (categoryModelId?: string, search?: string) => {
  if (!categoryModelId) {
    throw new Error("Brand ID and Model ID are required");
  }

  const queryParams = new URLSearchParams();
  if (search) {
    queryParams.append("search", search);
  }

  const endpoint = `/dealdrive/trim-options/${categoryModelId}${search ? `?${queryParams.toString()}` : ""}`;

  const response = await apiRequest<DealDriveTrim[]>(endpoint, {
    next: {
      revalidate: 3600, // Cache for 1 hour
      tags: [`dealdrive-trims-${categoryModelId}`],
    },
  });

  return response;
};

export const getDealDriveTrimsPaginated = async (
  inputValue: string,
  page?: number,
  filter?: Record<string, string>,
): Promise<PaginatedResponse<{ label: string; value: string }>> => {
  try {
    if (!filter?.categoryModelId) {
      return {
        data: [],
        meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
      };
    }

    const trims = await getDealDriveTrims(filter.categoryModelId, inputValue);

    const formattedTrims = trims.map((trim) => ({
      label: trim.node.name,
      value: trim.node.id.toString(),
    }));

    return {
      data: formattedTrims,
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  } catch (error) {
    console.error("Error fetching DealDrive trims:", error);
    return {
      data: [],
      meta: { currentPage: 1, totalPages: 1, hasNextPage: false },
    };
  }
};
